// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { Tag } from '@carbon/react';
import type { ChecklistItemStatus } from '../../../types';

type StatusTagType = 'gray' | 'green' | 'magenta' | 'cool-gray';

const STATUS_TAG: Record<ChecklistItemStatus, { type: StatusTagType; label: string }> = {
  expected: { type: 'gray', label: 'Open' },
  satisfied: { type: 'green', label: 'Satisfied' },
  needs_review: { type: 'magenta', label: 'Needs review' },
  bypassed: { type: 'cool-gray', label: 'Bypassed' },
};

/** Checklist status pill. Carbon Tag ships theme-correct fg/bg pairs for
 * g100/g10, so no custom colors are needed (ADR-0007). */
export default function CoverageStatusPill({ status }: { status: ChecklistItemStatus }) {
  const tag = STATUS_TAG[status] ?? { type: 'gray' as const, label: status };
  return (
    <Tag type={tag.type} size="sm" className="obw-status-pill">
      {tag.label}
    </Tag>
  );
}
